import { FC, useContext } from 'react'

import { Carat, Skeleton } from '@syconium/little-miss-figgy'

import { VariantSelectionFormContext } from '../../../app/_components/forms/VariantSelectionForm'
import { PriceText } from '../../../app/_components/pages/product-pages/ProductPage/DetailsSection/EmbroiderySection/EmbroiderySection.styles'
import { useFeatureFlag } from '../../../app/_providers/ExperimentationProvider.client'
import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { useExternalEmbroidery } from '../../../containers/EmbroideryContainer/providers/facade'
import { getInitialFormForEmbroideryType } from '../../../containers/EmbroideryContainer/utils/embroideryFormUtils'

import {
  CtaText,
  EmbroideryCtaGroup,
  EmbroideryCtaOptionButton,
  RightSideContent,
  SeparatedCtaText,
  EmbroideryCta as StyledEmbroideryCta,
} from './styles'

interface Props {
  showLowestPrice?: boolean
  isB2BColorSelected?: boolean
}

export const EmbroideryCta: FC<Props> = ({ showLowestPrice, isB2BColorSelected = false }) => {
  const {
    embroideryPriceRange,
    isLoadingSavedEmbroideryPreferences,
    productEmbroideryOptionKeys,
    setSelectedFormKind,
    isB2bEmbroidery,
    openEmbroideryModal,
  } = useExternalEmbroidery()

  const { embroidery: strings } = useTranslation()
  const variantSelectionFormContext = useContext(VariantSelectionFormContext)

  const showSeparateEmbroideryButtonsFlag = useFeatureFlag<'true' | 'false'>({
    key: 'separate-pdp-embroidery-buttons',
    controlVariant: 'false',
    ifAccessedPriorToDecisionInitialization: 'return-null-while-pending',
    skip: isB2BColorSelected || !variantSelectionFormContext,
  })

  if (
    isLoadingSavedEmbroideryPreferences ||
    !showSeparateEmbroideryButtonsFlag ||
    variantSelectionFormContext?.loading
  ) {
    return <Skeleton key='EmbroideryCtaButtonsSkeleton' height='40px' animated />
  }

  const showSeparateEmbroideryButtons =
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    showSeparateEmbroideryButtonsFlag === 'true' && productEmbroideryOptionKeys?.length > 1

  if (showSeparateEmbroideryButtons) {
    return (
      <EmbroideryCtaGroup>
        {productEmbroideryOptionKeys.map(nextEmbroideryType => {
          const formKey = getInitialFormForEmbroideryType({
            embroideryType: nextEmbroideryType,
            isB2b: isB2bEmbroidery,
          })
          const { embroideryFormKindTitles } = strings
          const label = embroideryFormKindTitles[formKey]
          return (
            <EmbroideryCtaOptionButton
              key={formKey}
              onClick={() => {
                setSelectedFormKind(formKey)
                openEmbroideryModal()
              }}
              aria-label={label}
              type='button'
            >
              <SeparatedCtaText>{label}</SeparatedCtaText>
            </EmbroideryCtaOptionButton>
          )
        })}
      </EmbroideryCtaGroup>
    )
  }

  return (
    <StyledEmbroideryCta
      onClick={() => {
        openEmbroideryModal()
      }}
      aria-label='Add Embroidery'
      type='button'
    >
      <CtaText>{strings.cta}</CtaText>
      <RightSideContent>
        {showLowestPrice && embroideryPriceRange?.min && (
          <CtaText>
            {strings.from} <PriceText>{embroideryPriceRange.min.displayValue}</PriceText>
          </CtaText>
        )}
        <Carat />
      </RightSideContent>
    </StyledEmbroideryCta>
  )
}
